"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("@spq/utils");
var geolib = _interopRequireWildcard(require("geolib"));
var _lodash = require("lodash");
var _moment = _interopRequireDefault(require("moment"));
var momentRange = _interopRequireWildcard(require("moment-range"));
var momentRound = _interopRequireWildcard(require("moment-round"));
var _gglocationUtils = require("./utils/gglocationUtils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var moment = momentRound.monkey(momentRange.extendMoment(_moment["default"]));
var Gglocation = exports["default"] = /*#__PURE__*/function () {
  function Gglocation(_ref) {
    var gglocation = _ref.gglocation,
      allTimeSlots = _ref.allTimeSlots;
    _classCallCheck(this, Gglocation);
    Object.assign(this, gglocation);
    this.allTimeSlots = allTimeSlots;
  }
  _createClass(Gglocation, [{
    key: "distanceToLocation",
    value: function distanceToLocation(_ref2) {
      var coordinates = _ref2.coordinates;
      var _this$coordinates = this.coordinates,
        lat = _this$coordinates.lat,
        lng = _this$coordinates.lng;
      return geolib.getDistance({
        latitude: lat,
        longitude: lng
      }, {
        latitude: coordinates.lat,
        longitude: coordinates.lng
      });
    }
  }, {
    key: "currentOpeningHours",
    get: function get() {
      var currentDate = moment();
      var openingHours = this.openingHours;
      var openingHoursFiltered = openingHours.filter(function (openingHoursDay) {
        return Gglocation.openingHoursDayRange({
          openingHoursDay: openingHoursDay
        }).contains(currentDate);
      });
      var openingHoursOnDate = openingHoursFiltered.length > 0 && openingHoursFiltered[0];
      return openingHoursOnDate;
    }
  }, {
    key: "selectedDateOpeningHours",
    value: function selectedDateOpeningHours() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref3$selectedDate = _ref3.selectedDate,
        selectedDate = _ref3$selectedDate === void 0 ? moment() : _ref3$selectedDate;
      var openingHours = this.openingHours;
      var openingHoursOnSelectedDate = openingHours.find(function (openingHoursDay) {
        return Gglocation.openingHoursDayRange({
          openingHoursDay: openingHoursDay
        }).contains(selectedDate);
      });
      return openingHoursOnSelectedDate;
    }
  }, {
    key: "isEnoughTimeToProcess",
    value: function isEnoughTimeToProcess(_ref4) {
      var processingTime = _ref4.processingTime;
      var currentOpeningHours = this.currentOpeningHours;
      if (!currentOpeningHours) {
        return false;
      }
      var closingDate = moment(currentOpeningHours.closingDatetime);
      var processedDate = moment().add(processingTime, "minutes");
      if (processedDate.isAfter(closingDate)) {
        return false;
      }
      return true;
    }
  }, {
    key: "getProcessingTime",
    value: function getProcessingTime(_ref5) {
      var diningChoice = _ref5.diningChoice,
        storeBusy = _ref5.storeBusy;
      var processingTime = this.processingTime[diningChoice] || this.processingTime["default"];
      if (storeBusy && (0, _gglocationUtils.checkIsStoreBusyValid)(storeBusy)) {
        return processingTime + storeBusy.extraTime;
      }
      return processingTime;
    }
  }, {
    key: "canPlaceInstantOrder",
    value: function canPlaceInstantOrder(_ref6) {
      var diningChoice = _ref6.diningChoice;
      var isAvailable = this.isAvailable,
        currentOpeningHours = this.currentOpeningHours;
      var processingTime = this.getProcessingTime({
        diningChoice: diningChoice
      });
      var isOpen = currentOpeningHours && isAvailable;
      return isOpen && this.isEnoughTimeToProcess({
        processingTime: processingTime
      });
    }
  }, {
    key: "getCutoffTime",
    value: function getCutoffTime(_ref7) {
      var diningChoice = _ref7.diningChoice;
      return this.cutoffTime[diningChoice] || this.cutoffTime["default"];
    }
  }, {
    key: "availableTimeSlots",
    get: function get() {
      var _this = this;
      var timeSlotsArray = this.timeSlots.map(function (timeSlotId) {
        return _this.allTimeSlots[timeSlotId];
      });
      var timeSlotsFiltered = timeSlotsArray.filter(function (timeSlot) {
        return timeSlot.itemSlotsAvailable > 0;
      });
      return timeSlotsFiltered;
    }
  }, {
    key: "nextTimeSlots",
    value: function nextTimeSlots(_ref8) {
      var diningChoice = _ref8.diningChoice;
      var availableTimeSlots = this.availableTimeSlots;
      var cutoffTime = this.getCutoffTime({
        diningChoice: diningChoice
      });
      var dateWithCutOff = moment().add(cutoffTime, "minutes");
      return availableTimeSlots.filter(function (timeSlot) {
        return moment(timeSlot.datetime).isAfter(dateWithCutOff);
      });
    }
  }, {
    key: "timeSlotsBeforeDay",
    value: function timeSlotsBeforeDay(_ref9) {
      var chosenDay = _ref9.chosenDay,
        diningChoice = _ref9.diningChoice;
      var timeSlotsFiltered = this.nextTimeSlots({
        diningChoice: diningChoice
      }).filter(function (timeSlot) {
        return moment(timeSlot.datetime).isBefore(moment(chosenDay), "day");
      });
      return timeSlotsFiltered;
    }
  }, {
    key: "timeSlotsAfterDay",
    value: function timeSlotsAfterDay(_ref10) {
      var chosenDay = _ref10.chosenDay,
        diningChoice = _ref10.diningChoice;
      var timeSlotsFiltered = this.nextTimeSlots({
        diningChoice: diningChoice
      }).filter(function (timeSlot) {
        return moment(timeSlot.datetime).isAfter(moment(chosenDay), "day");
      });
      return timeSlotsFiltered;
    }
  }, {
    key: "timeSlotsOnSameDay",
    value: function timeSlotsOnSameDay(_ref11) {
      var chosenDay = _ref11.chosenDay,
        diningChoice = _ref11.diningChoice;
      var timeSlotsFiltered = this.nextTimeSlots({
        diningChoice: diningChoice
      }).filter(function (timeSlot) {
        return moment(timeSlot.datetime).isSame(moment(chosenDay), "day");
      });
      return timeSlotsFiltered;
    }
  }, {
    key: "canPlaceOrderImmediately",
    value: function canPlaceOrderImmediately(_ref12) {
      var diningChoice = _ref12.diningChoice;
      if (this.type !== "scheduled") {
        return this.canPlaceInstantOrder({
          diningChoice: diningChoice
        });
      }
      var isAvailable = this.isAvailable;
      var chosenDay = moment();
      var hasTimeSlotsToday = this.timeSlotsOnSameDay({
        diningChoice: diningChoice,
        chosenDay: chosenDay
      });
      return isAvailable && hasTimeSlotsToday.length > 0;
    }
  }, {
    key: "willOpenAgain",
    get: function get() {
      var isAvailable = this.isAvailable,
        openingHours = this.openingHours;
      var currentDate = moment();
      var openingHoursFiltered = openingHours.filter(function (openingHoursDay) {
        return moment(openingHoursDay.openingDatetime).isAfter(currentDate);
      });
      var hasUpcomingHours = openingHoursFiltered.length > 0 && openingHoursFiltered[0];
      return hasUpcomingHours && isAvailable;
    }
  }, {
    key: "getNextTimeSlot",
    value: function getNextTimeSlot(_ref13) {
      var diningChoice = _ref13.diningChoice;
      var availableTimeSlots = this.availableTimeSlots;
      var cutoffTime = this.getCutoffTime({
        diningChoice: diningChoice
      });
      var dateWithCutOff = moment().add(cutoffTime, "minutes");
      return availableTimeSlots.find(function (timeSlot) {
        return moment(timeSlot.datetime).isAfter(dateWithCutOff);
      });
    }
  }, {
    key: "canPlaceOrderEver",
    value: function canPlaceOrderEver(_ref14) {
      var diningChoice = _ref14.diningChoice;
      if (this.type === "scheduled") {
        return this.isAvailable && this.getNextTimeSlot({
          diningChoice: diningChoice
        });
      }
      var willOpenAgain = this.willOpenAgain;
      return this.canPlaceInstantOrder({
        diningChoice: diningChoice
      }) || willOpenAgain;
    }
  }, {
    key: "getNextAvailableInstantDate",
    value: function getNextAvailableInstantDate(_ref15) {
      var diningChoice = _ref15.diningChoice;
      if (!this.canPlaceInstantOrder({
        diningChoice: diningChoice
      })) {
        return undefined;
      }
      var processingTime = this.processingTime[diningChoice] || this.processingTime["default"];
      return moment().add(processingTime, "minutes");
    }
  }, {
    key: "getScheduledOrderTimes",
    value: function getScheduledOrderTimes(_ref16) {
      var diningChoice = _ref16.diningChoice;
      if (!this.scheduledOrderTimes) {
        return this.scheduledOrderTimes;
      }
      return this.scheduledOrderTimes[diningChoice] || this.scheduledOrderTimes["default"];
    }
  }, {
    key: "possibleScheduledOrderDays",
    value: function possibleScheduledOrderDays(_ref17) {
      var diningChoice = _ref17.diningChoice;
      var cutoffTime = this.getCutoffTime({
        diningChoice: diningChoice
      });
      var scheduledOrderTimes = this.getScheduledOrderTimes({
        diningChoice: diningChoice
      });
      var earlierPossibleDate = moment().add(cutoffTime, "minutes");
      var dates = Object.keys(scheduledOrderTimes).filter(function (scheduledOrderTime) {
        var pickupTimes = scheduledOrderTimes[scheduledOrderTime];
        var validPickupTime = pickupTimes.find(function (pickupTime) {
          return earlierPossibleDate.isBefore(pickupTime);
        });
        return validPickupTime !== undefined;
      }).map(function (scheduledOrderTime) {
        return moment(scheduledOrderTime).startOf("day");
      }).sort(function (dateA, dateB) {
        return (0, _utils.compareDates)(dateA, dateB);
      });
      return dates;
    }
  }, {
    key: "earliestScheduledOrderDate",
    value: function earliestScheduledOrderDate(_ref18) {
      var diningChoice = _ref18.diningChoice;
      var cutoffTime = this.getCutoffTime({
        diningChoice: diningChoice
      });
      var scheduledOrderTimes = this.getScheduledOrderTimes({
        diningChoice: diningChoice
      });
      var earlierPossibleDate = moment().add(cutoffTime, "minutes");
      var earliestScheduledOrderDay = this.possibleScheduledOrderDays({
        diningChoice: diningChoice
      })[0];
      if (!earliestScheduledOrderDay) return undefined;
      return scheduledOrderTimes[earliestScheduledOrderDay.format("YYYY-MM-DD")].filter(function (pickupTime) {
        return earlierPossibleDate.isBefore(pickupTime);
      }).sort(function (dateA, dateB) {
        return (0, _utils.compareDates)(dateA, dateB);
      })[0];
    }
  }, {
    key: "getNextAvailableScheduledDate",
    value: function getNextAvailableScheduledDate(_ref19) {
      var diningChoice = _ref19.diningChoice;
      var willOpenAgain = this.willOpenAgain;
      if (!willOpenAgain) {
        return undefined;
      }
      var earliestScheduledOrderDate = this.earliestScheduledOrderDate({
        diningChoice: diningChoice
      });
      return moment(earliestScheduledOrderDate);
    }
  }, {
    key: "getNextAvailableTimeSlotDate",
    value: function getNextAvailableTimeSlotDate(_ref20) {
      var diningChoice = _ref20.diningChoice;
      var nextTimeSlot = this.getNextTimeSlot({
        diningChoice: diningChoice
      });
      if (!(this.isAvailable && nextTimeSlot)) {
        return undefined;
      }
      return moment(nextTimeSlot.datetime);
    }
  }, {
    key: "getNextAvailableDate",
    value: function getNextAvailableDate(_ref21) {
      var diningChoice = _ref21.diningChoice;
      if (this.type === "scheduled") {
        return this.getNextAvailableTimeSlotDate({
          diningChoice: diningChoice
        });
      }
      var nextAvailableInstantDate = this.getNextAvailableInstantDate({
        diningChoice: diningChoice
      });
      if (nextAvailableInstantDate) {
        return nextAvailableInstantDate;
      }
      var nextAvailableScheduledDate = this.getNextAvailableScheduledDate({
        diningChoice: diningChoice
      });
      if (nextAvailableScheduledDate) {
        return nextAvailableScheduledDate;
      }
      return null;
    }
  }, {
    key: "getScheduledOrderTimesOnSameDate",
    value: function getScheduledOrderTimesOnSameDate(_ref22) {
      var orderTime = _ref22.orderTime,
        diningChoice = _ref22.diningChoice,
        _ref22$includePast = _ref22.includePast,
        includePast = _ref22$includePast === void 0 ? false : _ref22$includePast;
      var cutoffTime = this.getCutoffTime({
        diningChoice: diningChoice
      });
      var scheduledOrderTimes = this.getScheduledOrderTimes({
        diningChoice: diningChoice
      });
      if (!scheduledOrderTimes || !scheduledOrderTimes[orderTime.format("YYYY-MM-DD")]) {
        return [];
      }
      var sameDayScheduledTime = scheduledOrderTimes[orderTime.format("YYYY-MM-DD")].map(function (scheduledOrderTimeString) {
        return moment(scheduledOrderTimeString);
      });
      if (includePast) {
        return sameDayScheduledTime;
      }
      var earlierPossibleDate = moment().add(cutoffTime, "minutes");
      return sameDayScheduledTime.filter(function (scheduledOrderTime) {
        return scheduledOrderTime.isAfter(earlierPossibleDate);
      });
    }
  }, {
    key: "getEnabledHours",
    value: function getEnabledHours(_ref23) {
      var orderTime = _ref23.orderTime,
        diningChoice = _ref23.diningChoice;
      return (0, _lodash.chain)(this.getScheduledOrderTimesOnSameDate({
        orderTime: orderTime,
        diningChoice: diningChoice
      })).map(function (scheduledOrderTime) {
        return scheduledOrderTime.hour();
      }).uniq().value();
    }
  }, {
    key: "getEnabledMinutes",
    value: function getEnabledMinutes(_ref24) {
      var orderTime = _ref24.orderTime,
        diningChoice = _ref24.diningChoice;
      return (0, _lodash.chain)(this.getScheduledOrderTimesOnSameDate({
        orderTime: orderTime,
        diningChoice: diningChoice
      })).filter(function (scheduledOrderTime) {
        return scheduledOrderTime.isSame(orderTime, "hour");
      }).map(function (scheduledOrderTime) {
        return scheduledOrderTime.minutes();
      }).uniq().value();
    }
  }], [{
    key: "openingHoursDayRange",
    value: function openingHoursDayRange(_ref25) {
      var openingHoursDay = _ref25.openingHoursDay;
      var openingDate = moment(openingHoursDay.openingDatetime);
      var closingDate = moment(openingHoursDay.closingDatetime);
      return moment.range(openingDate, closingDate);
    }
  }]);
  return Gglocation;
}();